// consumer.js - JavaScript file for readying a consumer

import { createConsumer } from "@rails/actioncable";

export default createConsumer();
